module.exports = __webpack_public_path__ + "img/lipas.4c5e0b9e.jpg";